import { ready, on } from "../utils/listeners";
import dispatchEvent from "../utils/events";
import api from "@/app/javascript/api";

ready(() => {
  on("click", ".js-search-trigger", () => {
    dispatchEvent("dialog:open", { id: "search" });

    api.post(`/suggested_searches`).then(response => {
      Turbo.renderStreamMessage(response.data);
    });
  });

  const noSearchInput = document.querySelector(".no-search-input");

  if (noSearchInput) {
    noSearchInput.focus();
  }
});
